import React from "react";
import { SecTitle, SecSubTitle, InfoMedia, FormOne } from "../../components";

const ContactOne = () => (
  <div
    className="background-image"
    style={{ backgroundImage: "url(images/bg/appoin-bg-1-1.jpg)" }}
  >
    <div className="container z-index-common">
      <div className="row gx-60">
        <div className="col-xl-6 align-self-center space">
          <SecSubTitle className="text-white">Make An Appointment</SecSubTitle>
          <SecTitle className="text-capitalize h1 text-white">
            We Provide Best Advice For Your Future
          </SecTitle>
          <hr className="hr-style1" />
          <p className="mb-4 mt-1 pb-3 text-white">
            {" "}
            At <strong>Tech Ayukta</strong>, we deliver reliable and
            future-ready IT solutions tailored to your specific business needs.
            Whether you're looking to streamline operations, scale your
            infrastructure, or enhance digital security—our team is ready to
            assist you anytime.
          </p>
          <div className="row gy-30">
            <div className="col-md-6">
              <InfoMedia
                className="contact-media"
                icon="fal fa-envelope"
                title="24/7 CALL AVAILABLE"
                info={<a href="tel:+919167195907">+91 9167195907</a>}
              />
            </div>
            <div className="col-md-6">
              <InfoMedia
              className="contact-media"
              icon="fab fa-whatsapp"
              title="WhatsApp Support"
              info={
                <a
                  href="https://wa.me/919167195907"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chat on WhatsApp
                </a>
              }
            />
            </div>
            
            <div className="col-md-12">
              <InfoMedia
                className="contact-media"
                icon="fal fa-envelope"
                title="Write a Quick mail"
                info={
                  <a href="mailto:techsupport@techayukta.com">
                    techsupport@techayukta.com
                  </a>
                }
              />
            </div>
            <div className="col-md-12">
              <InfoMedia
                className="contact-media"
                icon="fal fa-map-marker-alt"
                title="VISITE OFFICE"
                info="Accord Commercial Complex, Near BEST Bus Depot, Goregaon East, Mumbai – 400063"
              />
            </div>
            {/* <div className="col-md-6">
              <InfoMedia className="contact-media"
                icon="fal fa-envelope"
                title="VISITE GERMAN OFFICE"
                info="Kaiserbleek 4 Goslar, Lower Saxony "
              />
            </div> */}
          </div>
        </div>
        <div className="col-xl-6 form-wrap1">
          <FormOne title="Make An Appointment" btnText="Make An Appointment" />
        </div>
      </div>
    </div>
  </div>
);

export default ContactOne;
